import SurveyCountService from "../../service/surveyCount";

const Action = {
    GET_MISSION: "GET_MISSION",
    GET_MISSIONS: "GET_MISSIONS",
};


const ActionCreator = {
    getMission(missionId) {
        return async (dispatch) => {
            try {
                const mission = await SurveyCountService.findById(missionId);
                dispatch({type: Action.GET_MISSION, mission});
                return mission;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getMissions() {
        return async (dispatch) => {
            try {
                const missions = await SurveyCountService.list();
                dispatch({type: Action.GET_MISSIONS, missions});
                return missions;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    list: []
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_MISSION:
            return {
                ...state,
                ...action.mission
            };
        case Action.GET_MISSIONS:
            return {
                ...state,
                list: action.missions
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/surveyCount.js